export const profileData = {
  name: "N.Flying",
  debut_date: "2015-05-20",
  debut_song: "기가 막혀",
  cover_image_url: "/image/nflying_cover_image.webp",
  members: [
    {
      name: "이승협 (리더)",
      position: ["리드 보컬", "메인 래퍼"],
      aka: ["승짱", "밀루", "승또삐"],
      birthdate: "1992-10-31",
      imageUrl: "/image/member/seunghyub.webp",
      military: "2071-10-31",
      instagram: "https://www.instagram.com/sssn9_zzzn9/",
      mbti: "ESTP",
    },
    {
      name: "차훈",
      position: ["기타", "코러스"],
      aka: ["먐미", "사투리 스나이퍼"],
      birthdate: "1994-07-12",
      imageUrl: "/image/member/chahun.webp",
      military: "2073-07-12",
      instagram: "https://www.instagram.com/cchh_0712",
      mbti: "ISFJ",
    },
    {
      name: "김재현",
      position: ["드럼"],
      aka: ["옥탑방 드럼 걔", "쭒"],
      birthdate: "1994-07-15",
      imageUrl: "/image/member/jaehyun.webp",
      military: "2073-07-15",
      instagram: "https://www.instagram.com/_.kimjaehyun._",
      mbti: "ENFP",
    },
    {
      name: "유회승",
      position: ["메인보컬"],
      aka: ["승구", "말랑이", "하망이"],
      birthdate: "1995-02-28",
      imageUrl: "/image/member/hewseung.webp",
      military: "2074-02-28",
      instagram: "https://www.instagram.com/hweng_star",
      mbti: "ENFJ",
    },
    {
      name: "서동성",
      position: ["베이스", "코러스"],
      aka: ["막멩이", "뚱땅이"],
      birthdate: "1996-04-09",
      imageUrl: "/image/member/dongsung.webp",
      military: "2075-04-09",
      instagram: "https://www.instagram.com/9_6_meng22",
      mbti: "ISTJ",
    },
  ],
  fandom_name: "엔피아 (N.Fia)",
  light_stick: "엔피봉",
  official_sites: {
    x: "https://x.com/Nflyingofficial",
    facebook: "https://www.facebook.com/officialnflying",
    instagram: "https://www.instagram.com/letsroll_nf",
    youtube: "https://www.youtube.com/channel/UC8vm0EzlH9mRHwnTLILpQjQ",
    daumcafe: "https://cafe.daum.net/N.Flying"
  }
};
